import React, { useEffect, useState } from 'react';
import { MdOutlineCancel, MdOutlineSearch, MdPictureAsPdf } from 'react-icons/md';
import './Mi.css'; // Estilos personalizados
import { getUsuariosRol } from '../../services/UsuarioSucursal';

const SearchDocumento = ({ rol, asignacion, onValorSeleccionadoChange }) => {
  const [documentos, setDocumentos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  // Cargar documentos desde API cuando se abre el modal
  const fetchUsuarios = async () => {
    try {

      const miDataBusqueda = await getUsuariosRol(rol,asignacion);

      setDocumentos(miDataBusqueda || []);

      setFilteredDocs(miDataBusqueda || []); // 👈 Mostrar todos al inicio
    } catch (error) {
      console.error('Error al obtener documentos:', error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = documentos.filter((doc) =>
      doc.nombre?.toLowerCase().includes(value)
    );
    setFilteredDocs(filtered);
  };

  const handleSelect = (doc) => {
    onValorSeleccionadoChange(doc);
    setModalOpen(false);
    setSearchTerm('');
    setFilteredDocs([]);
  };  

  const openModal = () => {
    setSearchTerm('');
    setModalOpen(true);
    fetchUsuarios();
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="search-documento">
      <button
        type="button"
        className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold py-2 px-4 rounded shadow"
        onClick={openModal}
      >
        <div className="flex items-center gap-2">
          <MdOutlineSearch />
          Buscar
        </div>
      </button>

      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal bg-white shadow-lg p-6 rounded w-full max-w-2xl mx-auto mt-10 relative">
            <button
              type="button"
              onClick={closeModal}
              className="absolute top-2 right-2 text-xl text-gray-400 hover:text-gray-600"
            >
              <MdOutlineCancel />
            </button>

            <h2 className="text-lg font-semibold mb-4">Buscar Usuario</h2>

            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Escribe parte del nombre del archivo..."
              className="w-full border p-2 mb-4 rounded text-sm outline-none focus:ring"
            />

            {filteredDocs.length > 0 ? (
              <ul className="space-y-2 max-h-60 overflow-y-auto">
                {filteredDocs.map((doc) => (
                  <li
                    key={doc.idUsuario}
                    className="border p-3 rounded hover:bg-gray-100 cursor-pointer flex items-center gap-4 text-sm"
                    onClick={() => handleSelect(doc)}
                  >
                    <div className="flex flex-col">
                      <span className="font-medium">{doc.nombre}</span>
                      <span className="text-gray-500 text-xs">{doc.usuario}</span>
                      <span className="text-gray-500 text-xs">{doc.email} - {doc.telefono}</span>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 text-sm">No hay resultados disponibles.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchDocumento;